import type { TFunction } from 'i18next';
import { newCOLORS } from '../../styles/colors';
import { icons } from './assets';
import { Grouping } from './tasks-table.type';

/**
 * Build the grouping options shown in the tasks-table grouping select.
 * Accepts the caller's translation function so org-level text_config
 * overrides are picked up — a module-level constant initialized with
 * i18n.t() would freeze labels at import time.
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns Array of grouping options, each with label / value / icon / colors
 */
const getGroupingData = (t: TFunction) => [
  {
    label: t('common.initiative'),
    value: Grouping.Initiative,
    icon: icons.iconGroupingInitiative,
    bgColor: newCOLORS.lightOrange2,
    labelColor: newCOLORS.brown,
  },
  {
    label: t('common.parent_task'),
    value: Grouping.Epic,
    icon: icons.iconGroupingEpic,
    bgColor: newCOLORS.lighterPurple,
    labelColor: newCOLORS.darkBlue,
  },
  {
    label: t('common.estimation'),
    value: Grouping.Points,
    icon: icons.iconGroupingPoints,
    bgColor: newCOLORS.lighterGray2,
    labelColor: newCOLORS.darkerGray2,
  },
  {
    label: t('common.type'),
    value: Grouping.Type,
    icon: icons.iconGroupingType,
    bgColor: newCOLORS.lighterGray2,
    labelColor: newCOLORS.darkerGray2,
  },
];

export { getGroupingData };
